import React from 'react';

function PricePrediction(props) {
    return (
        <div>
            <p>
                It is an undeniable fact that obtaining a quality harvest takes a significant
                amount of time and work. It also involves precise tactical measures such as
                price prediction calculations, demand identification, weather forecasts, and so
                on. However, in Sri Lanka, farmers’ time and efforts yield minimal result. The
                primary cause for this scenario is that farmers are unable to forecast the price
                based on harvest demand. As a result, farmers have a difficult time finding a
                fair price for their crops. So that , the GreenHubLK price forecasting feature is
                the best solution to this issue. GreenHubLK’s market price forecasting feature
                can forecast a product’s future price by evaluating data from the preceding
                year. The data set used to forecast future market prices was obtained from
                Narahenpita’s economic center. The price, quantity, and relevant date are all part
                of the data collection. These are the exact prices and quantities that prevailed
                on the Narahenpita economic center each day.
            </p>
            <br/>
            <br/>

        </div>
    );
}

export default PricePrediction;
